import { JoinData } from './JoinDataInt';
import globalAudioData from './GlobalAudio';
import globalClimateData from './GlobalClimate';
import globalLightsData from './GlobalLights';
import globalShades from './GlobalShades';
import globalVideo from './GlobalVideo';
import homepageData from './Homepage';
import homepageSlideOutData from './HomepageSlideOut';
import intercomData from './Intercom';
import pool from './Pool';
import roomData from './Room';
import roomAudioMirage from './RoomAudioMirage';
import roomAudioSonosFavourites from './RoomAudioSonosFavourites';
import roomAudioSonosNowPlaying from './RoomAudioSonosNowPlaying';
import roomClimate from './RoomClimate';
import roomClimateScheduler from './RoomClimateScheduler';
import roomLightsScenesGrid from './RoomLightScenesGrid';
import roomLightsLoadsList from './RoomLightsLoadsList';
import roomLightsLoadsGrid from './RoomLightsLoadsGrid';
import roomLightsScenesList from './RoomLightsScenesList';
import roomsGrid from './RoomsGrid';
import roomShadesLoadsGrid from './RoomShadesLoadsGrid';
import roomShadesLoadsList from './RoomShadesLoadsList';
import roomShadesScenesGrid from './RoomShadesScenesGrid';
import roomShadesScenesList from './RoomShadesScenesList';
import roomsList from './RoomsList';
import roomVideoAppleTv from './RoomVideoAppleTv';
import roomVideoBluray from './RoomVideoBluray';
import roomVideoCableDVR from './RoomVideoCableDVR';
import roomVideoCableKeypad from './RoomVideoCableKeypad';
import roomVideoCableRemote from './RoomVideoCableRemote';
import roomVideoKaleidescape from './RoomVideoKaleidescape';
import roomVideoMultiplexDual from './RoomVideoMultiplexDual';
import roomVideoMultiplexSingle from './RoomVideoMultiplexSingle';
import roomVideoMultiplexQuad from './RoomVideoMultiplexQuad';
import roomVideoRoku from './RoomVideoRoku';
import roomVideoText from './RoomVideoText';
import securityCameras from './SecurityCameras';
import securitySystem from './SecuritySystem';
import securityZones from './SecurityZones';
import spa from './Spa';
import systems from './Systems';

const allSignals: JoinData[] = [
    ...globalAudioData,
    ...globalClimateData,
    ...globalLightsData,
    ...globalShades,
    ...globalVideo,
    ...homepageData,
    ...homepageSlideOutData,
    ...intercomData,
    ...pool,
    ...roomData,
    ...roomAudioMirage,
    ...roomAudioSonosFavourites,
    ...roomAudioSonosNowPlaying,
    ...roomClimate,
    ...roomClimateScheduler,
    ...roomLightsScenesGrid,
    ...roomLightsLoadsList,
    ...roomLightsLoadsGrid,
    ...roomLightsScenesList,
    ...roomsGrid,
    ...roomShadesLoadsGrid,
    ...roomShadesLoadsList,
    ...roomShadesScenesGrid,
    ...roomShadesScenesList,
    ...roomsList,
    ...roomVideoAppleTv,
    ...roomVideoBluray,
    ...roomVideoCableDVR,
    ...roomVideoCableKeypad,
    ...roomVideoCableRemote,
    ...roomVideoKaleidescape,
    ...roomVideoMultiplexDual,
    ...roomVideoMultiplexSingle,
    ...roomVideoMultiplexQuad,
    ...roomVideoRoku,
    ...roomVideoText,
    ...securityCameras,
    ...securitySystem,
    ...securityZones,
    ...spa,
    ...systems
];

const uniqueSignals = allSignals.reduce((acc: JoinData[], signal) => {
    if (!acc.find(s => s.join === signal.join)) {
        acc.push(signal);
    }
    return acc;
}, []);

export default uniqueSignals;